import * as React from "react";
import type { BaseIconProps } from "../../Icon.types";

export function DatabaseIcon({ size = 18, color, strokeColor, fillColor, className }: BaseIconProps) {
  const stroke = strokeColor ?? color ?? "currentColor";
  const fill = fillColor ?? "none";
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill={fill}
      stroke={stroke}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden
      className={className}
    >
      <ellipse cx="12" cy="5" rx="9" ry="3" />
      <path d="M21 12c0 1.66-4 3-9 3s-9-1.34-9-3" />
      <path d="M3 5v14c0 1.66 4 3 9 3s9-1.34 9-3V5" />
    </svg>
  );
}
